import { render, staticRenderFns } from "./MegaboardBanner.vue?vue&type=template&id=6bffe30d&"
import script from "./MegaboardBanner.vue?vue&type=script&lang=js&"
export * from "./MegaboardBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports